export const channelCn = {
    tijiaozhiliao:"提交资料",
    txgsxx:'填写公司信息，上传营业执照，填写您的收款信息，方便结算',
    sqqy:'申请签约',
    ddzzsh:'等待资质审核（1-3个工作日）审核通过，短信签约',
    rzcg:'入驻成功',
    lrxx:'录入信息',
    ptsh:'平台审核，审核通过即可营业',
    ljjr:'立即加入',
    txrzzl:'填写入驻资料',
    ptsh:'平台审核',
    rzcg:'入驻成功',
    zltjcg:'资料提交成功，请耐心等待平台审核',
    shsb:'审核失败,请重新填写注册信息并提交',
    shyj:'审核意见',
    cxtx:'重新填写',
    shtg:'恭喜您, 渠道信息已审核通过',
    jrjg:'进入渠道管理后台',
    qudsf:'渠道身份：',
    qyzf:'企业/政府（含企业、政府、事业单位、团体、组织）',
    geren:'个人',
    zhuanjia:'专家',
    qiyemc:'企业名称：',
    qsrqymc:'请输入企业名称',
    youxiang:'邮箱：',
    qingshuruyouxiang:'请输入邮箱',
    shoujihaoma:'手机号码：',
    qingshurusj:'请输入手机',
    tyjgdm:'统一机构代码证：',
    qsrtyjgdm:'请输入统一机构代码证',
    qyszd:'企业所在地：',
    qsrxxdz:'请输入详细地址',
    gsclny:'公司成立年月：',
    qxzrq:'请选择日期',
    gszczb:"公司注册资本：",
    qsrgszczb:'请输入公司注册资本',
    gsjj:'公司简介：',
    qsrgsjj:'请输入公司简介',
    scfrsfz:'上传法人身份证扫描件：',
    sfzzm:'身份证正面上传',
    sfzfm:'身份证反面上传',
    qyzyyz:'上传企业营业执照复印件（需盖公章）扫描件：',
    zzzs:'上传资质证书扫描件（可选上传多份）：',
    scjjzl:'上传简介材料：',
    scsqs:'上传平台注册账号经办人授权书：',
    baocun:'保存草稿',
    tijiao:'提交',
    woyiydty:'我已阅读并同意',
    xiyi:'《贸促通产品检测认证平台协议》',
    zsxm:'真实姓名：',
    qsrzsxm:'请输入真实姓名',
    suozaidi:'所在地：',
    guojia:'国家',
    scbljl:'上传公安机关出证的暂无不良记录扫描文件：',
    zjmc:'专家名称：',
    qsrzjmc:'请输入专家名称',
    zjszdz:'专家所在地址：',
    zjzxxm:'专家咨询项目：',
    qingxunzhe:'请选择',
    zjzl:"专家资历：",
    zjjl:'专家简介：',
    qsrzjjj:'请输入专家简介',
    scsfzsmj:'上传专家身份证扫描件：',
    sczjzzsmj:'上传专家资质证书扫描件（可选上传多份）：',
    sczjlw:'上传专家个人论文：',
    qxzgj:'请选择国家',
    qxzsheng:'请选择省',
    qxzshi:'请选择市',
    qxzfu:'请选择服务',
    qxzhy:'请选择行业',
    qxzzlnf:'请选择资历年份',
    youxiangbwk:'邮箱不能为空',
    qingshuruzqyx:'请输入正确的邮箱格式',
    shoujibwk:'手机号不能为空',
    qingshuruzqsj:'请输入正确的手机号',
    qsrgszczj:'请输入公司注册资金',
    qxzgsclnf:'请选择公司成立年份',
    cdxz:'长度在 3 到 12个字符'
}


// WEBPACK FOOTER //
// ./src/lang/home/channel/channelCn.js